import { render, staticRenderFns } from "./MortgageAmountsPopUp.vue?vue&type=template&id=add62354&scoped=true&"
import script from "./MortgageAmountsPopUp.vue?vue&type=script&lang=js&"
export * from "./MortgageAmountsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MortgageAmountsPopUp.vue?vue&type=style&index=0&id=add62354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add62354",
  null
  
)

export default component.exports